export const shiftColors = [
  { label: ' ', name: 'Electric Pink', code: '#fc3644' },
  { label: ' ', name: 'Red Rose', code: '#ab1438' },
  { label: ' ', name: 'Apricot', code: '#fc5c42' },
  { label: ' ', name: 'Pink Sand', code: '#feb69c' },
  { label: ' ', name: 'Turquoise', code: '#91cec2' },
  { label: ' ', name: 'Mint', code: '#a2ec8e' },
  { label: ' ', name: 'Pollen', code: '#fecb4d' },
  { label: ' ', name: 'Cream', code: '#ffe0ab' },
  { label: ' ', name: 'Blue', code: '#1ea5fc' },
  { label: ' ', name: 'Cerulian', code: '#87b9e7' },
  { label: ' ', name: 'Linen Blue', code: '#455785' },
  { label: ' ', name: 'Purple100', code: '#CE87D5' },
  { label: ' ', name: 'Purple200', code: '#8962f8' },
  { label: ' ', name: 'Lavender', code: '#a58998' },
  { label: ' ', name: 'Pine Green', code: '#00897B' },
  { label: ' ', name: 'Mist Blue', code: '#A7AB99' },
  { label: ' ', name: 'Soft White', code: '#d8c9af' },
  { label: ' ', name: 'Yellow Gold', code: '#cc996d' },
  { label: ' ', name: 'Coastal Gray', code: '#715d50' },
  { label: ' ', name: 'Gray', code: '#A2A2A2' },
]

export const pageStyles = {
  beauty: 'beauty',
  ohbot: 'ohbot',
}

export const pageStyleName = {
  [pageStyles.beauty]: '美業版',
  [pageStyles.ohbot]: '標準版',
}

export const pageStyleList = Object.keys(pageStyleName).map(key => {
  return {
    name: pageStyleName[key],
    value: key,
  }
})

export const pageTextKeys = {
  category: 'APPOINTMENT_CATEGORY',
  service: 'APPOINTMENT_SERVICE',
  unit: 'APPOINTMENT_UNIT',
  serviceAttach: 'APPOINTMENT_SERVICE_ATTACH',
  subService: 'APPOINTMENT_SUB_SERVICE',
}

export const pageTextDefault = [
  {
    key: 'APPOINTMENT_CATEGORY',
    default: '服務類別',
  },
  {
    key: 'APPOINTMENT_SERVICE',
    default: '服務項目',
  },
  {
    key: 'APPOINTMENT_UNIT',
    default: '服務人員',
  },
  {
    key: 'APPOINTMENT_SERVICE_ATTACH',
    default: '附加服務',
  },
  {
    key: 'APPOINTMENT_SUB_SERVICE',
    default: '子項目',
  },
]

export const orderOrigins = {
  client: { label: 'orderInfoBlock.origin.client.title', value: 'client' },
  admin: { label: 'orderInfoBlock.origin.admin.title', value: 'admin' },
  openAPI: { label: 'orderInfoBlock.origin.openApi.title', value: 'openapi' },
  pubApt: { label: 'orderInfoBlock.origin.pubApt.title', value: 'pubApt' },
  coday: { label: 'orderInfoBlock.origin.coday.title', value: 'coday' },
}

export const pageTextDefaultValue = pageTextDefault.reduce((data, field) => ({ ...data, [field.key]: '' }), {})

export const tableFilterOptions = [
  { label: '電話號碼', value: 'phone' },
  { label: '訂單類型', value: 'orderType' },
  { label: '預約日期', value: 'date' },
  { label: '預約時間', value: 'time' },
  { label: '服務項目', value: 'service' },
  { label: '預約來源', value: 'origin' },
  { label: '訂單總額', value: 'totalPrice' },
  { label: '應付定金', value: 'deposit' },
  { label: '付款方式', value: 'payment' },
]

export const orderStatusConfig = {
  cancel: { name: 'reservationList.status.cancel.title', value: 'cancel', tag: 'danger' },
  wait: { name: 'reservationList.status.wait.title', value: 'wait', tag: 'info' },
  complete: { name: 'reservationList.status.complete.title', value: 'complete', tag: 'action' },
  absence: { name: 'reservationList.status.absence.title', value: 'absence', tag: 'wait' },
  confirm: { name: 'reservationList.status.confirm.title', value: 'confirm', tag: 'warning' },
}

export const orderHistoryEventTypeConfig = {
  confirm: { label: '訂單確認中，尚未付款', value: 'confirm' },
  paid: { label: '訂單已付款', value: 'paid' },
  paidFailed: { label: '付款失敗', value: 'paidFailed' },
  paidExpired: { label: '付款已過期', value: 'paidExpired' },
  created: { label: '建立預約記錄', value: 'created' },
  updatedTime: { label: '訂單變更 - 服務時間', value: 'updatedTime' },
  updatedInfo: { label: '訂單變更', value: 'updatedInfo' },
  wait: { label: '訂單已預約', value: 'wait' },
  cancel: { label: '訂單已取消', value: 'cancel' },
  complete: { label: '訂單已完成', value: 'complete' },
  absence: { label: '顧客未到', value: 'absence' },
  waitRefund: { label: '訂單等待退款中', value: 'waitRefund' },
  paidWaitRefund: { label: '訂單等待退款中', value: 'paidWaitRefund' },
  refund: { label: '訂單已完成退款', value: 'refund' },
  paidRefund: { label: '訂單已完成退款', value: 'paidRefund' },
  replyPending: { label: '訂單等待回覆', value: 'replyPending' },
  replyReplied: { label: '訂單回覆已完成', value: 'replyReplied' },
  replyExpired: { label: '訂單回覆已逾時', value: 'replyExpired' },
  replyNoReplyNeeded: { label: '訂單無需回覆', value: 'replyNoReplyNeeded' },
}

export const orderHistorySourceConfig = {
  system: { label: '系統', value: 'system' },
  admin: { label: '後台', value: 'admin' },
  client: { label: '顧客', value: 'client' },
}

export const noSpecifyUnitOrderOptionConfig = {
  first: { label: 'reservationNotspecifySettings.notSpecifyName.first.title', value: 'first' },
  last: { label: 'reservationNotspecifySettings.notSpecifyName.last.title', value: 'last' },
}

export const notSpecifyRules = {
  order: { value: 'order', label: '按排序大小' },
  reservation: { value: 'reservation', label: '預約數分配' },
  notSpecifyReservation: { value: 'notSpecifyReservation', label: '不指定預約數分配' },
  random: { value: 'random', label: '隨機' },
}

export const serviceClassTicketStatusConfig = {
  open: { label: '未使用', value: 'open' },
  complete: { label: '已使用', value: 'complete' },
  overdue: { label: '已過期', value: 'overdue' },
  cancel: { label: '已取消', value: 'cancel' },
  booked: { label: '已預扣', value: 'booked' },
}

export const serviceTypeConfig = {
  humanService: { label: 'serviceTypeConfig.humanService.title', value: 'humanService' },
  resourceService: { label: 'serviceTypeConfig.resourceService.title', value: 'resourceService' },
  humanAndResourceService: { label: 'serviceTypeConfig.humanAndResourceService.title', value: 'humanAndResourceService' },
}

export const notSpecifyRulesConfig = {
  order: { value: 'order', label: 'reservationNotspecifySettings.notSpecifyRule.order.title' },
  reservation: { value: 'reservation', label: 'reservationNotspecifySettings.notSpecifyRule.reservation.title' },
  notSpecifyReservation: {
    value: 'notSpecifyReservation',
    label: 'reservationNotspecifySettings.notSpecifyRule.notSpecifyReservation.title',
  },
  random: { value: 'random', label: 'reservationNotspecifySettings.notSpecifyRule.random.title' },
}

export const batchOrderStatusConfig = {
  unpaid: { name: 'reservationList.batchOrderStatus.unpaid.title', value: 'unpaid', tag: 'warning' },
  paid: { name: 'reservationList.batchOrderStatus.paid.title', value: 'paid', tag: 'action' },
  refund: { name: 'reservationList.batchOrderStatus.refund.title', value: 'refund', tag: 'info' },
  fail: { name: 'reservationList.batchOrderStatus.fail.title', value: 'fail', tag: 'danger' },
  cancel: { name: 'reservationList.batchOrderStatus.cancel.title', value: 'cancel', tag: 'danger' },
}

export const displayPeriodConfig = {
  all: { label: '全部開啟顯示', value: 'all' },
  empty: { label: '全部關閉顯示', value: 'empty' },
  custom: { label: '部分顯示', value: 'custom' },
}

export const displayExcludePeriodConfig = {
  once: { label: '不重複', value: 'once' },
  weekly: { label: '每週重複', value: 'weekly' },
  monthly: { label: '每月重複', value: 'monthly' },
  yearly: { label: '每年重複', value: 'yearly' },
}

export const storeBusinessTimeTypeConfig = [
  { label: '依照分店營業時間與分店排除特定時段', value: 'FollowShop' },
  { label: '門市特定時間營業', value: 'CustomWeek' },
  { label: '24小時營業', value: '24Hours' },
]

export const replyStatusConfig = {
  pending: { name: 'reservationList.replyStatus.pending.title', value: 'pending', tag: 'info' },
  replied: { name: 'reservationList.replyStatus.replied.title', value: 'replied', tag: 'action' },
  expired: { name: 'reservationList.replyStatus.expired.title', value: 'expired', tag: 'danger' },
  no_reply_needed: { name: 'reservationList.replyStatus.no_reply_needed.title', value: 'no_reply_needed', tag: 'info' },
}

export const cancelReasonConfig = {
  conflict: { label: '行程衝突', value: 'conflict', tag: 'info' },
  health: { label: '身體不適', value: 'health', tag: 'danger' },
  traffic: { label: '交通天氣', value: 'traffic', tag: 'warning' },
  budget: { label: '預算考量', value: 'budget', tag: 'action' },
  reschedule: { label: '更改預約時間', value: 'reschedule', tag: 'action' },
  other: { label: '其他', value: 'other', tag: 'info' },
}

export const cancelSourceConfig = {
  client: { label: 'C 端顧客自行取消', value: 'client' },
  admin: { label: 'B 端店家代為取消', value: 'admin' },
  openAPI: { label: 'OpenAPI 取消', value: 'openAPI' },
  system: { label: '系統取消', value: 'system' },
  pubApt: { label: '跨境預約取消', value: 'pubApt' },
  coday: { label: 'Coday 取消', value: 'coday' },
}
